/**
 * PrepMetaStrip — the metadata strip at the top of an opened preparation
 * request: status badge, TEST badge, submitted date, who loaded it (§26.1),
 * the annual-review meeting context (§34.11) and the NB progress count.
 * Extracted verbatim from PrepRequestDetail.jsx (step P7 of the
 * PrepRequestDetail decomposition, audit §6.2); the moved block keeps its
 * original indentation.
 */

import { getFirstName } from '../../auth/authConfig';
import { formatPrepYmd, isPrepOriginator, STATUS_LABELS, STATUS_COLOURS } from '../../utils/prepRequests';
// Month names only — a pure constant; no planner/stat logic is imported.
import { MONTH_NAMES } from '../../utils/reviewPlanner';

export default function PrepMetaStrip({ prep, user, isNB, done, total }) {
  const statusColour = STATUS_COLOURS[prep.status] || '#6B7A8D';
  return (
      <div style={styles.metaStrip}>
        <span style={{ ...styles.statusBadge, background: `${statusColour}1A`, color: statusColour }}>
          {STATUS_LABELS[prep.status] || prep.status}
        </span>
        {/* TEST badge — test records only (CLAUDE.md §33). Existing design
            tokens only. */}
        {prep.isTest && (
          <span
            style={{
              ...styles.statusBadge,
              background: 'var(--cp-surface-alt)',
              border: '1px dashed var(--cp-warning)',
              color: 'var(--cp-warning)',
            }}
          >
            TEST
          </span>
        )}
        <span style={styles.metaItem}>Submitted: {formatPrepYmd((prep.createdAt || '').slice(0, 10))}</span>
        {/* WHO ASKED FOR THIS (§26.1) — the originator, which is now either
            the Adviser or the Administration Assistant. Never assume the
            Adviser here or in any future notification. */}
        <span style={styles.metaItem}>
          Loaded by: {prep.createdBy ? getFirstName(prep.createdBy) : '—'}
          {isPrepOriginator(prep, user?.email) ? ' (you)' : ''}
        </span>
        {/* Segmented review-handoff request (§34.11): meeting context. */}
        {prep.memberSections && (
          <span style={styles.metaItem}>
            Annual Review · {MONTH_NAMES[prep.memberSections.reviewMonth] || ''}{' '}
            {prep.memberSections.reviewYear} · {(prep.memberSections.sections || []).length} clients
          </span>
        )}
        {isNB && prep.status === 'in_progress' && (
          <span style={styles.metaItem}>Progress: {done} / {total} tasks</span>
        )}
      </div>
  );
}

const styles = {
  metaStrip: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    marginBottom: '1rem',
    flexWrap: 'wrap',
  },
  statusBadge: {
    fontSize: '0.7rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    padding: '0.15rem 0.6rem',
    borderRadius: '999px',
  },
  metaItem: {
    fontSize: '0.8rem',
    color: 'var(--cp-text-muted)',
  },
};
